import { FC, memo } from 'react';
import map from 'lodash/map';

import { csvFormatColumns } from 'components/ImportCsv/constants';
import { LINKS } from 'utils/constants/constants';

const CsvFormat: FC = () =>
  <div className="w-200 min-w-200 p-15 border-default regular">
    <p className="semi-bold m-b-10">CSV format</p>
    <span>The file must be a CSV file with the and should include the next fields as the names of the columns:</span>
    <ul className="p-l-25">{map(csvFormatColumns, (column) => <li key={column}>{column}</li>)}</ul>
    <a href={LINKS.autoDs.importCsv} download className="blue">Download example file</a>
  </div>;

export default memo(CsvFormat);
